import React from "react";
import Styleloader from "./pageloader.module.css";
import logo from "../Ui/logo.png";

const Pageloader = () => {
  return (
    // <div className={Styleloader.loader}>
    //   <img src={logo} alt="HopeRise Logo" className={Styleloader.loaderlogo} />
    // </div>
    // <div className={Styleloader.loader}>
    //   <div className={Styleloader.loadercontent}>
    //     <img src={logo} alt="HopeRise Logo" className={Styleloader.loaderlogo}/>
    //     <h2 className={Styleloader.loadertext}>HopeRise</h2>
    //   </div>
    // </div>

    <div className={Styleloader.loader}>
      <div className={Styleloader.loadercontent}>
        <img src={logo} alt="HopeRise Logo" className={Styleloader.loaderlogo}/>
        <div className={Styleloader.dots}>
          <span className={Styleloader.dot}></span>
          <span className={Styleloader.dot}></span>
          <span className={Styleloader.dot}></span>
        </div>
      </div>
    </div>

    
  );
};

export default Pageloader;
